import { Text, Tooltip } from '@mantine/core';
import React from 'react';

interface UnderlineTooltipProps {
  label: string;
  children: React.ReactNode;
}

export function UnderlineTooltip({ label, children }: UnderlineTooltipProps) {
  return (
    <Tooltip label={label}>
      <Text
        fw={600}
        size="md"
        c="gray.10"
        style={{
          borderBottom: '1px dotted var(--mantine-color-gray-10)',
          display: 'inline-block',
        }}
      >
        {children}
      </Text>
    </Tooltip>
  );
}
